import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=ae718804&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=ts"
export * from "./SocialLogin.vue?vue&type=script&lang=ts"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=ae718804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae718804",
  null
  
)

export default component.exports